import { each } from 'lodash';
import Swiper from 'swiper/bundle';

export class CarouselNowadays {
    constructor() {
        this.carousel = {
            elements: document.querySelectorAll('.carousel[data-carousel="nowadays"]'),
        }

        each(this.carousel.elements, (carousel) => {
            this.createCarousel(carousel); // Init Carousel
        });
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            grabCursor: true,
            navigation: {
                nextEl: "[data-next]",
                prevEl: "[data-prev]",
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
            },
        });

        if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
            target.setAttribute('data-draggable',true)
        }
    }
}
export class CarouselHonorable {
    constructor() {
        this.carousel = {
            elements: document.querySelectorAll('.carousel[data-carousel="honorable"]'),
        }

        each(this.carousel.elements, (carousel) => {
            this.createCarousel(carousel); // Init Carousel
        });
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            grabCursor: true,
            navigation: {
                nextEl: "[data-next]",
                prevEl: "[data-prev]",
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
            },
        });

        if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
            target.setAttribute('data-draggable',true)
        }
    }
}